import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'

export function StudentMenu(): JSX.Element {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/student/'

  const menuItems = useMemo(
    () => [
      {permission: null, title: t('MENU.PROFILE'), to: `${base}my-profile`},

      {permission: null, title: t('LABEL.SCHEDULE'), to: `${base}schedule`},

      {permission: null, title: t('LABEL.ATTENDANCE'), to: `${base}attendance`},

      {permission: null, title: t('LABEL.MARKS'), to: `${base}marks`},

      {permission: null, title: t('LABEL.PAYMENTS'), to: `${base}payments`},
      {permission: null, title: t('CHAT.CHAT'), to: `/chat/dua-std-chat-room`},
    ],
    [t]
  )

  const renderEntry = (item: any, index: any) => {
    if (item.permission && !hasPermission(item.permission)) return null

    if (item.children) {
      const visibleChildren = item.children.filter(
        (c: any) => !c.permission || hasPermission(c.permission)
      )
      if (!visibleChildren.length) return null

      return (
        <MenuInnerWithSub
          key={index}
          title={item.title}
          to={item.to}
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
        >
          {visibleChildren.map((child: any, index: any) => (
            <MenuItem key={index} to={child.to} title={child.title} fontIcon={child.fontIcon} />
          ))}
        </MenuInnerWithSub>
      )
    }

    return <MenuItem key={item.to} title={item.title} to={item.to} />
  }

  return <>{menuItems.map(renderEntry)}</>
}
